/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CommentCreate = {
    properties: {
        content: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
